var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.34375C1.5 6.03125 2.75 3.90625 4.75 2.71875C6.78125 1.5625 9.25 1.5625 11.25 2.71875C13.2812 3.90625 14.5 6.03125 14.5 8.34375C14.5 10.6875 13.2812 12.8125 11.25 14C9.25 15.1562 6.78125 15.1562 4.75 14C2.75 12.8125 1.5 10.6875 1.5 8.34375ZM16 8.34375C16 5.5 14.5 2.875 12 1.4375C9.53125 0 6.5 0 4 1.4375C1.53125 2.875 0 5.5 0 8.34375C0 11.2188 1.53125 13.8438 4 15.2812C6.5 16.7188 9.53125 16.7188 12 15.2812C14.5 13.8438 16 11.2188 16 8.34375ZM8.46875 12.125C8.78125 12.4375 9.25 12.4375 9.53125 12.125C9.84375 11.8438 9.84375 11.375 9.53125 11.0625L6.8125 8.34375L9.53125 5.625C9.84375 5.34375 9.84375 4.875 9.53125 4.5625C9.25 4.28125 8.78125 4.28125 8.46875 4.5625L5.21875 7.84375C4.9375 8.125 4.9375 8.59375 5.21875 8.875L8.46875 12.125Z",
    fill: "#22333B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCircleRight);
export default __webpack_public_path__ + "static/media/chevron-circle-right.12510ce10353936f9a446f6dab9c3c63.svg";
export { ForwardRef as ReactComponent };